export default "__VITE_ASSET__izFTk_Ge__"